import { takeLatest, put, delay } from "redux-saga/effects";
import { ActionTypes, Update } from "@app/store/reducers/app.reducer";

function* loadSaga(): any
{
    try 
    {
        yield delay(1000);
        yield put(Update({ loaded: true }));
    }
    catch (error)
    {
        console.log(error);
        //yield put(fetchTasksError(error.message));
    }
}

export function* watchAppSaga()
{
    yield takeLatest(ActionTypes.Load, loadSaga);
}

export default watchAppSaga;